import { create } from 'zustand';

import { PlanCategory } from '@/shared/types/Billing';
import { User } from '@/shared/types/User';

import { DEFAULT_BALANCE } from '../lib/defaultBalance';
import { getBalance } from '../lib/getBalance';

type BalanceStore = {
  availableFreeVideos: number;
  availableMinutes: number;
  canBuyMinutes: boolean;
  hasActiveEnterprisePlan: boolean;
  hasActiveSubscription: boolean;
  hasArchivedSubscription: boolean;
  hasCanceledSubscription: boolean;
  hasEnterprisePlan: boolean;
  hasExpiredSubscription: boolean;
  hasFreeLipSyncMinutes: boolean;
  hasFreeSubscription: boolean;
  hasFreeVideos: boolean;
  hasMinutes: boolean;
  hasPastDueSubscription: boolean;
  hasPausedSubscription: boolean;
  hasSubscriptionCancelAtPeriodEnd: boolean;
  hasSubscriptionWithArchivedPrice: boolean;
  hasTrialingEnterprisePlan: boolean;
  hasTrialPlan: boolean;
  hasUnpaidSubscription: boolean;
  planCategory?: PlanCategory;
  planName?: string;
};

type BalanceStoreActions = {
  resetBalance: () => void;
  setBalance: (user: User) => void;
  updateBalance: (updatedBalance: Partial<BalanceStore>) => void;
};

export const useBalanceStore = create<BalanceStore & BalanceStoreActions>((set) => ({
  ...DEFAULT_BALANCE,

  resetBalance: () => set({ ...DEFAULT_BALANCE }),

  setBalance: (user) =>
    set(() => ({
      ...getBalance(user),
    })),

  updateBalance: (updatedBalance) =>
    set((state) => {
      const { planName } = updatedBalance;

      if (!planName) {
        return {
          ...updatedBalance,
          planName: state.hasFreeSubscription || state.hasTrialPlan ? 'Free Plan' : 'Archive Plan',
        };
      }

      return updatedBalance;
    }),
}));

const hasEnoughMinutesToDubSelector = (state: BalanceStore, projectDuration?: null | number) => {
  if (!projectDuration) {
    return false;
  }

  return state.availableMinutes >= Math.ceil(projectDuration / 60);
};

export const useHasEnoughMinutesToDub = (projectDuration?: null | number) => {
  return useBalanceStore((state) => hasEnoughMinutesToDubSelector(state, projectDuration));
};
